// PURPOSE: Load the default call playbook when the caller first opens the script.
// CONTRACT: Spec 081 preserves saved text and local edits through subsequent toggles.
// DEPENDS: Session API, CallScript and shared error presentation.
// CEILING: No writes; CallingCard passes the edited text to Log call.
import { useRef, useState } from 'react';
import { useSession } from './auth';
import { ErrorNotice } from './components';
import { dateLabel } from './domain';
import { CallScript } from './outreach-script';

type Playbook = { script: string; missing: string[]; own: boolean };
export function CallPlaybook({ clientId, stored, seededAt, value, onChange }: {
  clientId: string; stored: boolean; seededAt?: string; value: string; onChange(value: string): void;
}) {
  const { api } = useSession();
  const started = useRef(false); const edited = useRef(false);
  const [loading, setLoading] = useState(false); const [error, setError] = useState<unknown>();
  const [missing, setMissing] = useState<string[]>([]);
  async function open() {
    if (stored || started.current) return;
    started.current = true; setLoading(true);
    try {
      const result = await api.request<Playbook>(`/outreach/candidates/${encodeURIComponent(clientId)}/call-script`);
      if (!edited.current) { onChange(result.script); setMissing(result.missing); }
    } catch (caught) { setError(caught); }
    finally { setLoading(false); }
  }
  return <section aria-label="Call script"><details onToggle={event => { if (event.currentTarget.open) void open(); }}>
    <summary>Call script</summary>
    {loading && <p className="small muted" role="status">Loading call script…</p>}
    {!!error && <ErrorNotice error={error} />}
    {missing.length > 0 && <p className="small muted">Needs: {missing.join(', ')}</p>}
    {seededAt && <p className="small muted">Drafted by your AI on {dateLabel(seededAt)} · edit freely</p>}
    <CallScript value={value} onChange={text => { edited.current = true; onChange(text); }} />
  </details></section>;
}
